export default function TripCheckoutCarController(
    carService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        composeCompanyLogoUrl: carService.getCarSupplierLogo,
        moment,
});
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-car-controller.js